var items = {
  "block.minecraft.air": "aire",
  "block.minecraft.stone": "ròca",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "granit polit",
  "block.minecraft.diorite": "diorita",
  "block.minecraft.polished_diorite": "diorita polida",
  "block.minecraft.andesite": "andesita",
  "block.minecraft.polished_andesite": "andesita polida",
  "block.minecraft.grass_block": "blòc d'èrba",
  "block.minecraft.dirt": "tèrra",
  "block.minecraft.coarse_dirt": "tèrra estèrla",
  "block.minecraft.podzol": "podzòl",
  "block.minecraft.crimson_nylium": "nicèli cremesin",
  "block.minecraft.warped_nylium": "nicèli bescornut",
  "block.minecraft.cobblestone": "pèiras",
  "block.minecraft.oak_planks": "plancas d'euse",
  "block.minecraft.spruce_planks": "plancas d'avet",
  "block.minecraft.birch_planks": "plancas de bèç",
  "block.minecraft.jungle_planks": "plancas de jungla",
  "block.minecraft.acacia_planks": "plancas de cacièr",
  "block.minecraft.dark_oak_planks": "plancas d'euse escur",
  "block.minecraft.crimson_planks": "plancas cremesinas",
  "block.minecraft.warped_planks": "plancas bescornudas",
  "block.minecraft.oak_sapling": "grelh d'euse",
  "block.minecraft.spruce_sapling": "grelh d'avet",
  "block.minecraft.birch_sapling": "grelh de bèç",
  "block.minecraft.jungle_sapling": "grelh de jungla",
  "block.minecraft.acacia_sapling": "grelh de cacièr",
  "block.minecraft.dark_oak_sapling": "grelh d'euse escur",
  "block.minecraft.bedrock": "ròca de basa",
  "block.minecraft.sand": "sabla",
  "block.minecraft.red_sand": "sabla roja",
  "block.minecraft.gravel": "grava",
  "block.minecraft.gold_ore": "minièra d'aur",
  "block.minecraft.iron_ore": "minièra de fèrre",
  "block.minecraft.coal_ore": "minièra de carbon",
  "block.minecraft.nether_gold_ore": "minièra d'aur dau nether",
  "block.minecraft.oak_log": "busca d'euse",
  "block.minecraft.spruce_log": "busca d'avet",
  "block.minecraft.birch_log": "busca de bèç",
  "block.minecraft.jungle_log": "busca de jungla",
  "block.minecraft.acacia_log": "busca de cacièr",
  "block.minecraft.dark_oak_log": "busca d'euse escur",
  "block.minecraft.crimson_stem": "tija cremesina",
  "block.minecraft.warped_stem": "tija bescornuda",
  "block.minecraft.stripped_oak_log": "busca d'euse deruschat",
  "block.minecraft.stripped_spruce_log": "busca d'avet deruschat",
  "block.minecraft.stripped_birch_log": "busca de bèç deruschat",
  "block.minecraft.stripped_jungle_log": "busca de jungla deruschat",
  "block.minecraft.stripped_acacia_log": "busca de cacièr deruschat",
  "block.minecraft.stripped_dark_oak_log": "busca d'euse escur deruschat",
  "block.minecraft.stripped_crimson_stem": "tija cremesina deruschada",
  "block.minecraft.stripped_warped_stem": "tija bescornuda deruschada",
  "block.minecraft.stripped_oak_wood": "fusta d'euse deruschat",
  "block.minecraft.stripped_spruce_wood": "fusta d'avet deruschat",
  "block.minecraft.stripped_birch_wood": "fusta de bèç deruschat",
  "block.minecraft.stripped_jungle_wood": "fusta de jungla deruschat",
  "block.minecraft.stripped_acacia_wood": "fusta de cacièr deruschat",
  "block.minecraft.stripped_dark_oak_wood": "fusta d'euse escur deruschat",
  "block.minecraft.stripped_crimson_hyphae": "ifas cremesinas deruschadas",
  "block.minecraft.stripped_warped_hyphae": "ifas bescornudas deruschadas",
  "block.minecraft.oak_wood": "fusta d'euse",
  "block.minecraft.spruce_wood": "fusta d'avet",
  "block.minecraft.birch_wood": "fusta de bèç",
  "block.minecraft.jungle_wood": "fusta de jungla",
  "block.minecraft.acacia_wood": "fusta de cacièr",
  "block.minecraft.dark_oak_wood": "fusta d'euse escur",
  "block.minecraft.crimson_hyphae": "ifas cremesinas",
  "block.minecraft.warped_hyphae": "ifas bescornudas",
  "block.minecraft.oak_leaves": "fuèlhas d'euse",
  "block.minecraft.spruce_leaves": "fuèlhas d'avet",
  "block.minecraft.birch_leaves": "fuèlhas de bèç",
  "block.minecraft.jungle_leaves": "fuèlhas de jungla",
  "block.minecraft.acacia_leaves": "fuèlhas de cacièr",
  "block.minecraft.dark_oak_leaves": "fuèlhas d'euse escur",
  "block.minecraft.sponge": "esponja",
  "block.minecraft.wet_sponge": "esponja trempada",
  "block.minecraft.glass": "veire",
  "block.minecraft.lapis_ore": "minièra de lapislazuli",
  "block.minecraft.lapis_block": "blòc de lapislazuli",
  "block.minecraft.dispenser": "distribuïdor",
  "block.minecraft.sandstone": "gres",
  "block.minecraft.chiseled_sandstone": "gres escultat",
  "block.minecraft.cut_sandstone": "gres talhat",
  "block.minecraft.note_block": "blòc musicau",
  "block.minecraft.powered_rail": "ralh propulsor",
  "block.minecraft.detector_rail": "ralh detector",
  "block.minecraft.sticky_piston": "piston pegós",
  "block.minecraft.cobweb": "telaranha",
  "block.minecraft.grass": "èrba",
  "block.minecraft.fern": "fauguièra",
  "block.minecraft.dead_bush": "arbust mòrt",
  "block.minecraft.seagrass": "èrba marina",
  "block.minecraft.sea_pickle": "cornisson de mar",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "lana blanca",
  "block.minecraft.orange_wool": "lana iranja",
  "block.minecraft.magenta_wool": "lana magenta",
  "block.minecraft.light_blue_wool": "lana blau clar",
  "block.minecraft.yellow_wool": "lana jauna",
  "block.minecraft.lime_wool": "lana lima",
  "block.minecraft.pink_wool": "lana ròsa",
  "block.minecraft.gray_wool": "lana grisa",
  "block.minecraft.light_gray_wool": "lana gris clar",
  "block.minecraft.cyan_wool": "lana cian",
  "block.minecraft.purple_wool": "lana violeta",
  "block.minecraft.blue_wool": "lana blava",
  "block.minecraft.brown_wool": "lana bruna",
  "block.minecraft.green_wool": "lana verda",
  "block.minecraft.red_wool": "lana roja",
  "block.minecraft.black_wool": "lana negra",
  "block.minecraft.dandelion": "pissalach",
  "block.minecraft.poppy": "rosèla",
  "block.minecraft.blue_orchid": "orquidèa blava",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "houstonia caerulea",
  "block.minecraft.red_tulip": "tulipa roja",
  "block.minecraft.orange_tulip": "tulipa iranja",
  "block.minecraft.white_tulip": "tulipa blanca",
  "block.minecraft.pink_tulip": "tulipa ròsa",
  "block.minecraft.oxeye_daisy": "margarida",
  "block.minecraft.cornflower": "blavet",
  "block.minecraft.lily_of_the_valley": "muguet",
  "block.minecraft.wither_rose": "ròsa de wither",
  "block.minecraft.brown_mushroom": "camparòu brun",
  "block.minecraft.red_mushroom": "camparòu roge",
  "block.minecraft.crimson_fungus": "fonge cremesin",
  "block.minecraft.warped_fungus": "fonge bescornut",
  "block.minecraft.crimson_roots": "raices cremesins",
  "block.minecraft.warped_roots": "raices bescornuts",
  "block.minecraft.nether_sprouts": "brots dau nether",
  "block.minecraft.weeping_vines": "lianas plorosas",
  "block.minecraft.twisting_vines": "lianas torsadas",
  "block.minecraft.sugar_cane": "cana de sucre",
  "block.minecraft.kelp": "auga",
  "block.minecraft.bamboo": "bambó",
  "block.minecraft.gold_block": "blòc d'aur",
  "block.minecraft.iron_block": "blòc de fèrre",
  "block.minecraft.oak_slab": "lausa en euse",
  "block.minecraft.spruce_slab": "lausa en avet",
  "block.minecraft.birch_slab": "lausa en bèç",
  "block.minecraft.jungle_slab": "lausa de jungla",
  "block.minecraft.acacia_slab": "lausa de cacièr",
  "block.minecraft.dark_oak_slab": "lausa en euse escur",
  "block.minecraft.crimson_slab": "lausa cremesina",
  "block.minecraft.warped_slab": "lausa bescornuda",
  "block.minecraft.stone_slab": "lausa de ròca",
  "block.minecraft.smooth_stone_slab": "lausa de ròca lisa",
  "block.minecraft.sandstone_slab": "lausa de gres",
  "block.minecraft.cut_sandstone_slab": "lausa en gres talhat",
  "block.minecraft.petrified_oak_slab": "lausa en euse petrificada",
  "block.minecraft.cobblestone_slab": "lausa de pèiras",
  "block.minecraft.brick_slab": "lausa en bricas",
  "block.minecraft.stone_brick_slab": "lausa en bricas de pèira",
  "block.minecraft.nether_brick_slab": "lausa en bricas dau nether",
  "block.minecraft.quartz_slab": "lausa en qüars",
  "block.minecraft.red_sandstone_slab": "lausa de gres roge",
  "block.minecraft.cut_red_sandstone_slab": "lausa en gres roge talhat",
  "block.minecraft.purpur_slab": "lausa de porpra",
  "block.minecraft.prismarine_slab": "lausa de prismarina",
  "block.minecraft.prismarine_brick_slab": "lausa en bricas de prismarina",
  "block.minecraft.dark_prismarine_slab": "lausa de prismarina escura",
  "block.minecraft.smooth_quartz": "blòc de qüars lis",
  "block.minecraft.smooth_red_sandstone": "gres roge lis",
  "block.minecraft.smooth_sandstone": "gres lis",
  "block.minecraft.smooth_stone": "ròca lisa",
  "block.minecraft.bricks": "bricas",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "bibliotèca",
  "block.minecraft.mossy_cobblestone": "pèiras mofudas",
  "block.minecraft.obsidian": "obsidiana",
  "block.minecraft.torch": "entòrcha",
  "block.minecraft.end_rod": "barra de l'end",
  "block.minecraft.chorus_plant": "planta de còrus",
  "block.minecraft.chorus_flower": "flor de còrus",
  "block.minecraft.purpur_block": "blòc de porpra",
  "block.minecraft.purpur_pillar": "pilar de porpra",
  "block.minecraft.purpur_stairs": "escalièrs de porpra",
  "block.minecraft.spawner": "generator",
  "block.minecraft.oak_stairs": "escalièrs en euse",
  "block.minecraft.chest": "còfre",
  "block.minecraft.diamond_ore": "minièra de diamant",
  "block.minecraft.diamond_block": "blòc de diamant",
  "block.minecraft.crafting_table": "taula de trabalh",
  "block.minecraft.farmland": "tèrra laurada",
  "block.minecraft.furnace": "forn",
  "block.minecraft.ladder": "escala",
  "block.minecraft.rail": "ralh",
  "block.minecraft.cobblestone_stairs": "escalièrs de pèiras",
  "block.minecraft.lever": "agre",
  "block.minecraft.stone_pressure_plate": "placa de pression en ròca",
  "block.minecraft.oak_pressure_plate": "placa de pression en euse",
  "block.minecraft.spruce_pressure_plate": "placa de pression en avet",
  "block.minecraft.birch_pressure_plate": "placa de pression en bèç",
  "block.minecraft.jungle_pressure_plate": "placa de pression de jungla",
  "block.minecraft.acacia_pressure_plate": "placa de pression en cacièr",
  "block.minecraft.dark_oak_pressure_plate": "placa de pression en euse escur",
  "block.minecraft.crimson_pressure_plate": "placa de pression cremesina",
  "block.minecraft.warped_pressure_plate": "placa de pression bescornuda",
  "block.minecraft.polished_blackstone_pressure_plate": "placa de pression en ròca negra polida",
  "block.minecraft.redstone_ore": "minièra de redstone",
  "block.minecraft.redstone_torch": "entòrcha de redstone",
  "block.minecraft.snow": "nèu",
  "block.minecraft.ice": "glaç",
  "block.minecraft.snow_block": "blòc de nèu",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "argila",
  "block.minecraft.jukebox": "tocadisques",
  "block.minecraft.oak_fence": "barralha en euse",
  "block.minecraft.spruce_fence": "barralha en avet",
  "block.minecraft.birch_fence": "barralha en bèç",
  "block.minecraft.jungle_fence": "barralha de jungla",
  "block.minecraft.acacia_fence": "barralha en cacièr",
  "block.minecraft.dark_oak_fence": "barralha en euse escur",
  "block.minecraft.crimson_fence": "barralha cremesina",
  "block.minecraft.warped_fence": "barralha bescornuda",
  "block.minecraft.pumpkin": "coja",
  "block.minecraft.carved_pumpkin": "coja escultada",
  "block.minecraft.netherrack": "ròca dau nether",
  "block.minecraft.soul_sand": "sabla d'anmas",
  "block.minecraft.soul_soil": "sòu d'anmas",
  "block.minecraft.basalt": "basalte",
  "block.minecraft.polished_basalt": "basalte polit",
  "block.minecraft.soul_torch": "entòrcha d'anmas",
  "block.minecraft.glowstone": "pèira luminosa",
  "block.minecraft.jack_o_lantern": "lantèrna coja",
  "block.minecraft.oak_trapdoor": "trapa en euse",
  "block.minecraft.spruce_trapdoor": "trapa en avet",
  "block.minecraft.birch_trapdoor": "trapa en bèç",
  "block.minecraft.jungle_trapdoor": "trapa de jungla",
  "block.minecraft.acacia_trapdoor": "trapa en cacièr",
  "block.minecraft.dark_oak_trapdoor": "trapa en euse escur",
  "block.minecraft.crimson_trapdoor": "trapa cremesina",
  "block.minecraft.warped_trapdoor": "trapa bescornuda",
  "block.minecraft.infested_stone": "ròca infestada",
  "block.minecraft.infested_cobblestone": "pèiras infestadas",
  "block.minecraft.infested_stone_bricks": "bricas de pèira infestadas",
  "block.minecraft.infested_mossy_stone_bricks": "bricas de pèira mofuda infestadas",
  "block.minecraft.infested_cracked_stone_bricks": "bricas de pèira fendilhada infestadas",
  "block.minecraft.infested_chiseled_stone_bricks": "bricas de pèira escultada infestadas",
  "block.minecraft.stone_bricks": "bricas de pèira",
  "block.minecraft.mossy_stone_bricks": "bricas de pèira mofudas",
  "block.minecraft.cracked_stone_bricks": "bricas de pèira fendilhadas",
  "block.minecraft.chiseled_stone_bricks": "bricas de pèira escultadas",
  "block.minecraft.brown_mushroom_block": "blòc de camparòu brun",
  "block.minecraft.red_mushroom_block": "blòc de camparòu roge",
  "block.minecraft.mushroom_stem": "tija de camparòu",
  "block.minecraft.iron_bars": "barrets de fèrre",
  "block.minecraft.chain": "cadena",
  "block.minecraft.glass_pane": "panèu de veire",
  "block.minecraft.melon": "pastèca",
  "block.minecraft.vine": "lianas",
  "block.minecraft.oak_fence_gate": "pòrta de barralha en euse",
  "block.minecraft.spruce_fence_gate": "pòrta de barralha en avet",
  "block.minecraft.birch_fence_gate": "pòrta de barralha en bèç",
  "block.minecraft.jungle_fence_gate": "pòrta de barralha de jungla",
  "block.minecraft.acacia_fence_gate": "pòrta de barralha en cacièr",
  "block.minecraft.dark_oak_fence_gate": "pòrta de barralha en euse escur",
  "block.minecraft.crimson_fence_gate": "pòrta de barralha cremesina",
  "block.minecraft.warped_fence_gate": "pòrta de barralha bescornuda",
  "block.minecraft.brick_stairs": "escalièrs en bricas",
  "block.minecraft.stone_brick_stairs": "escalièrs en bricas de pèira",
  "block.minecraft.mycelium": "micèli",
  "block.minecraft.lily_pad": "nimfèia",
  "block.minecraft.nether_bricks": "bricas dau nether",
  "block.minecraft.cracked_nether_bricks": "bricas dau nether fendilhadas",
  "block.minecraft.chiseled_nether_bricks": "bricas dau nether escultadas",
  "block.minecraft.nether_brick_fence": "barralha en bricas dau nether",
  "block.minecraft.nether_brick_stairs": "escalièrs en bricas dau nether",
  "block.minecraft.enchanting_table": "taula d'encantament",
  "block.minecraft.end_portal_frame": "quadre dau portau de l'end",
  "block.minecraft.end_stone": "ròca de l'end",
  "block.minecraft.end_stone_bricks": "bricas de pèira de l'end",
  "block.minecraft.dragon_egg": "uòu de dragon",
  "block.minecraft.redstone_lamp": "lum de redstone",
  "block.minecraft.sandstone_stairs": "escalièrs en gres",
  "block.minecraft.emerald_ore": "minièra d'esmerauda",
  "block.minecraft.ender_chest": "còfre de l'end",
  "block.minecraft.tripwire_hook": "cròc",
  "block.minecraft.emerald_block": "blòc d'esmerauda",
  "block.minecraft.spruce_stairs": "escalièrs en avet",
  "block.minecraft.birch_stairs": "escalièrs en bèç",
  "block.minecraft.jungle_stairs": "escalièrs de jungla",
  "block.minecraft.crimson_stairs": "escalièrs cremesins",
  "block.minecraft.warped_stairs": "escalièrs bescornuts",
  "block.minecraft.command_block": "blòc de comandas",
  "block.minecraft.beacon": "balisa",
  "block.minecraft.cobblestone_wall": "mur de pèiras",
  "block.minecraft.mossy_cobblestone_wall": "mur de pèiras mofudas",
  "block.minecraft.brick_wall": "muret de bricas",
  "block.minecraft.prismarine_wall": "muret de prismarina",
  "block.minecraft.red_sandstone_wall": "muret de gres roge",
  "block.minecraft.mossy_stone_brick_wall": "muret en bricas de pèiras mofudas",
  "block.minecraft.granite_wall": "muret de granit",
  "block.minecraft.stone_brick_wall": "muret en bricas de pèira",
  "block.minecraft.nether_brick_wall": "muret en bricas dau nether",
  "block.minecraft.andesite_wall": "muret d'andesita",
  "block.minecraft.red_nether_brick_wall": "muret en bricas dau nether rojas",
  "block.minecraft.sandstone_wall": "muret de gres",
  "block.minecraft.end_stone_brick_wall": "muret en bricas de pèira de l'end",
  "block.minecraft.diorite_wall": "muret de diorita",
  "block.minecraft.blackstone_wall": "muret de ròca negra",
  "block.minecraft.polished_blackstone_wall": "muret de ròca negra polida",
  "block.minecraft.polished_blackstone_brick_wall": "muret en bricas de ròca negra polida",
  "block.minecraft.stone_button": "boton en pèira",
  "block.minecraft.oak_button": "boton en euse",
  "block.minecraft.spruce_button": "boton en avet",
  "block.minecraft.birch_button": "boton en bèç",
  "block.minecraft.jungle_button": "boton de jungla",
  "block.minecraft.acacia_button": "boton en cacièr",
  "block.minecraft.dark_oak_button": "boton en euse escur",
  "block.minecraft.crimson_button": "boton cremesin",
  "block.minecraft.warped_button": "buton bescornut",
  "block.minecraft.polished_blackstone_button": "boton de ròca negra polida",
  "block.minecraft.anvil": "enclutge",
  "block.minecraft.chipped_anvil": "enclutge bercat",
  "block.minecraft.damaged_anvil": "enclutge damatjat",
  "block.minecraft.trapped_chest": "còfre trapa",
  "block.minecraft.light_weighted_pressure_plate": "placa de pression per pes leugièr",
  "block.minecraft.heavy_weighted_pressure_plate": "placa de pression per pes elevat",
  "block.minecraft.daylight_detector": "detector de lutz solara",
  "block.minecraft.redstone_block": "blòc de redstone",
  "block.minecraft.nether_quartz_ore": "minièra de qüars dau nether",
  "block.minecraft.hopper": "embut",
  "block.minecraft.chiseled_quartz_block": "blòc de qüars escultat",
  "block.minecraft.quartz_block": "blòc de qüars",
  "block.minecraft.quartz_bricks": "bricas de qüars",
  "block.minecraft.quartz_pillar": "pilar de qüars",
  "block.minecraft.quartz_stairs": "escalièrs en qüars",
  "block.minecraft.activator_rail": "ralh activator",
  "block.minecraft.dropper": "donaire",
  "block.minecraft.white_terracotta": "tèrra cuècha blanca",
  "block.minecraft.orange_terracotta": "tèrra cuècha iranja",
  "block.minecraft.magenta_terracotta": "tèrra cuècha magenta",
  "block.minecraft.light_blue_terracotta": "tèrra cuècha blau clar",
  "block.minecraft.yellow_terracotta": "tèrra cuècha jauna",
  "block.minecraft.lime_terracotta": "tèrra cuècha verd clar",
  "block.minecraft.pink_terracotta": "tèrra cuècha ròsa",
  "block.minecraft.gray_terracotta": "tèrra cuècha grisa",
  "block.minecraft.light_gray_terracotta": "tèrra cuècha gris clar",
  "block.minecraft.cyan_terracotta": "tèrra cuècha cian",
  "block.minecraft.purple_terracotta": "tèrra cuècha violeta",
  "block.minecraft.blue_terracotta": "tèrra cuècha blava",
  "block.minecraft.brown_terracotta": "tèrra cuècha bruna",
  "block.minecraft.green_terracotta": "tèrra cuècha verda",
  "block.minecraft.red_terracotta": "tèrra cuècha roja",
  "block.minecraft.black_terracotta": "tèrra cuècha negra",
  "block.minecraft.barrier": "barralha invisibla",
  "block.minecraft.iron_trapdoor": "trapa en fèrre",
  "block.minecraft.hay_block": "bala de fen",
  "block.minecraft.white_carpet": "moqueta blanca",
  "block.minecraft.orange_carpet": "moqueta iranja",
  "block.minecraft.magenta_carpet": "moqueta magenta",
  "block.minecraft.light_blue_carpet": "moqueta blau clar",
  "block.minecraft.yellow_carpet": "moqueta jauna",
  "block.minecraft.lime_carpet": "moqueta lima",
  "block.minecraft.pink_carpet": "moqueta ròsa",
  "block.minecraft.gray_carpet": "moqueta grisa",
  "block.minecraft.light_gray_carpet": "moqueta gris clar",
  "block.minecraft.cyan_carpet": "moqueta cian",
  "block.minecraft.purple_carpet": "moqueta violeta",
  "block.minecraft.blue_carpet": "moqueta blava",
  "block.minecraft.brown_carpet": "moqueta bruna",
  "block.minecraft.green_carpet": "moqueta verda",
  "block.minecraft.red_carpet": "moqueta roja",
  "block.minecraft.black_carpet": "moqueta negra",
  "block.minecraft.terracotta": "tèrra cuècha",
  "block.minecraft.coal_block": "blòc de carbon",
  "block.minecraft.packed_ice": "glaç compactat",
  "block.minecraft.acacia_stairs": "escalièrs en cacièr",
  "block.minecraft.dark_oak_stairs": "escalièrs en euse escur",
  "block.minecraft.slime_block": "blòc de slime",
  "block.minecraft.grass_path": "camin d'èrba",
  "block.minecraft.sunflower": "virasolelh",
  "block.minecraft.lilac": "lillac",
  "block.minecraft.rose_bush": "rosièr",
  "block.minecraft.peony": "peuna",
  "block.minecraft.tall_grass": "èrba nauta",
  "block.minecraft.large_fern": "fauguièra granda",
  "block.minecraft.white_stained_glass": "veire blanc",
  "block.minecraft.orange_stained_glass": "veire irange",
  "block.minecraft.magenta_stained_glass": "veire magenta",
  "block.minecraft.light_blue_stained_glass": "veire blau clar",
  "block.minecraft.yellow_stained_glass": "veire jaune",
  "block.minecraft.lime_stained_glass": "veire lima",
  "block.minecraft.pink_stained_glass": "veire ròse",
  "block.minecraft.gray_stained_glass": "veire gris",
  "block.minecraft.light_gray_stained_glass": "veire gris clar",
  "block.minecraft.cyan_stained_glass": "veire cian",
  "block.minecraft.purple_stained_glass": "veire violet",
  "block.minecraft.blue_stained_glass": "veire blau",
  "block.minecraft.brown_stained_glass": "veire brun",
  "block.minecraft.green_stained_glass": "veire verd",
  "block.minecraft.red_stained_glass": "veire roge",
  "block.minecraft.black_stained_glass": "veire negre",
  "block.minecraft.white_stained_glass_pane": "panèu de veire blanc",
  "block.minecraft.orange_stained_glass_pane": "panèu de veire irange",
  "block.minecraft.magenta_stained_glass_pane": "panèu de veire magenta",
  "block.minecraft.light_blue_stained_glass_pane": "panèu de veire blau clar",
  "block.minecraft.yellow_stained_glass_pane": "panèu de veire jaune",
  "block.minecraft.lime_stained_glass_pane": "panèu de veire lima",
  "block.minecraft.pink_stained_glass_pane": "panèu de veire ròse",
  "block.minecraft.gray_stained_glass_pane": "panèu de veire gris",
  "block.minecraft.light_gray_stained_glass_pane": "panèu de veire gris clar",
  "block.minecraft.cyan_stained_glass_pane": "panèu de veire cian",
  "block.minecraft.purple_stained_glass_pane": "panèu de veire violet",
  "block.minecraft.blue_stained_glass_pane": "panèu de veire blau",
  "block.minecraft.brown_stained_glass_pane": "panèu de veire brun",
  "block.minecraft.green_stained_glass_pane": "panèu de veire verd",
  "block.minecraft.red_stained_glass_pane": "panèu de veire roge",
  "block.minecraft.black_stained_glass_pane": "panèu de veire negre",
  "block.minecraft.prismarine": "prismarina",
  "block.minecraft.prismarine_bricks": "bricas de prismarina",
  "block.minecraft.dark_prismarine": "prismarina escura",
  "block.minecraft.prismarine_stairs": "escalièrs en prismarina",
  "block.minecraft.prismarine_brick_stairs": "escalièrs en bricas de prismarina",
  "block.minecraft.dark_prismarine_stairs": "escalièrs en prismarina escura",
  "block.minecraft.sea_lantern": "lantèrna marina",
  "block.minecraft.red_sandstone": "gres roge",
  "block.minecraft.chiseled_red_sandstone": "gres roge escultat",
  "block.minecraft.cut_red_sandstone": "gres roge talhat",
  "block.minecraft.red_sandstone_stairs": "escalièrs en gres roge",
  "block.minecraft.repeating_command_block": "blòc de comandas a repeticion",
  "block.minecraft.chain_command_block": "blòc de comandas en cadena",
  "block.minecraft.magma_block": "blòc de magma",
  "block.minecraft.nether_wart_block": "blòc de botiòlas dau nether",
  "block.minecraft.warped_wart_block": "blòc de botiòlas bescornudas dau nether",
  "block.minecraft.red_nether_bricks": "bricas dau nether rojas",
  "block.minecraft.bone_block": "blòc d'òsses",
  "block.minecraft.structure_void": "void d'estructura",
  "block.minecraft.observer": "observator",
  "block.minecraft.shulker_box": "bóstia de shulker",
  "block.minecraft.white_shulker_box": "bóstia de shulker blanca",
  "block.minecraft.orange_shulker_box": "bóstia de shulker iranja",
  "block.minecraft.magenta_shulker_box": "bóstia de shulker magenta",
  "block.minecraft.light_blue_shulker_box": "bóstia de shulker blau clar",
  "block.minecraft.yellow_shulker_box": "bóstia de shulker jauna",
  "block.minecraft.lime_shulker_box": "bóstia de shulker verd clar",
  "block.minecraft.pink_shulker_box": "bóstia de shulker ròsa",
  "block.minecraft.gray_shulker_box": "bóstia de shulker grisa",
  "block.minecraft.light_gray_shulker_box": "bóstia de shulker gris clar",
  "block.minecraft.cyan_shulker_box": "bóstia de shulker cian",
  "block.minecraft.purple_shulker_box": "bóstia de shulker violeta",
  "block.minecraft.blue_shulker_box": "bóstia de shulker blava",
  "block.minecraft.brown_shulker_box": "bóstia de shulker bruna",
  "block.minecraft.green_shulker_box": "bóstia de shulker verda",
  "block.minecraft.red_shulker_box": "bóstia de shulker roja",
  "block.minecraft.black_shulker_box": "bóstia de shulker negra",
  "block.minecraft.white_glazed_terracotta": "tèrra cuècha esmautada blanca",
  "block.minecraft.orange_glazed_terracotta": "tèrra cuècha esmautada iranja",
  "block.minecraft.magenta_glazed_terracotta": "tèrra cuècha esmautada magenta",
  "block.minecraft.light_blue_glazed_terracotta": "tèrra cuècha esmautada blau clar",
  "block.minecraft.yellow_glazed_terracotta": "tèrra cuècha esmautada jauna",
  "block.minecraft.lime_glazed_terracotta": "tèrra cuècha esmautada lima",
  "block.minecraft.pink_glazed_terracotta": "tèrra cuècha esmautada ròsa",
  "block.minecraft.gray_glazed_terracotta": "tèrra cuècha esmautada grisa",
  "block.minecraft.light_gray_glazed_terracotta": "tèrra cuècha esmautada gris clar",
  "block.minecraft.cyan_glazed_terracotta": "tèrra cuècha esmautada cian",
  "block.minecraft.purple_glazed_terracotta": "tèrra cuècha esmautada violeta",
  "block.minecraft.blue_glazed_terracotta": "tèrra cuècha esmautada blava",
  "block.minecraft.brown_glazed_terracotta": "tèrra cuècha esmautada bruna",
  "block.minecraft.green_glazed_terracotta": "tèrra cuècha esmautada verda",
  "block.minecraft.red_glazed_terracotta": "tèrra cuècha esmautada roja",
  "block.minecraft.black_glazed_terracotta": "tèrra cuècha esmautada negra",
  "block.minecraft.white_concrete": "beton blanc",
  "block.minecraft.orange_concrete": "beton irange",
  "block.minecraft.magenta_concrete": "beton magenta",
  "block.minecraft.light_blue_concrete": "beton blau clar",
  "block.minecraft.yellow_concrete": "beton jaune",
  "block.minecraft.lime_concrete": "beton lima",
  "block.minecraft.pink_concrete": "beton ròse",
  "block.minecraft.gray_concrete": "beton gris",
  "block.minecraft.light_gray_concrete": "beton gris clar",
  "block.minecraft.cyan_concrete": "beton cian",
  "block.minecraft.purple_concrete": "beton violet",
  "block.minecraft.blue_concrete": "beton blau",
  "block.minecraft.brown_concrete": "beton brun",
  "block.minecraft.green_concrete": "beton verd",
  "block.minecraft.red_concrete": "beton roge",
  "block.minecraft.black_concrete": "beton negre",
  "block.minecraft.white_concrete_powder": "polsa de beton blanca",
  "block.minecraft.orange_concrete_powder": "polsa de beton iranja",
  "block.minecraft.magenta_concrete_powder": "polsa de beton magenta",
  "block.minecraft.light_blue_concrete_powder": "polsa de beton blau clar",
  "block.minecraft.yellow_concrete_powder": "polsa de beton jauna",
  "block.minecraft.lime_concrete_powder": "polsa de beton lima",
  "block.minecraft.pink_concrete_powder": "polsa de beton ròsa",
  "block.minecraft.gray_concrete_powder": "polsa de beton grisa",
  "block.minecraft.light_gray_concrete_powder": "polsa de beton gris clar",
  "block.minecraft.cyan_concrete_powder": "polsa de beton cian",
  "block.minecraft.purple_concrete_powder": "polsa de beton violeta",
  "block.minecraft.blue_concrete_powder": "polsa de beton blava",
  "block.minecraft.brown_concrete_powder": "polsa de beton bruna",
  "block.minecraft.green_concrete_powder": "polsa de beton verda",
  "block.minecraft.red_concrete_powder": "polsa de beton roja",
  "block.minecraft.black_concrete_powder": "polsa de beton negra",
  "block.minecraft.turtle_egg": "uòu de tartuga",
  "block.minecraft.dead_tube_coral_block": "blòc de coralh tubular mòrt",
  "block.minecraft.dead_brain_coral_block": "blòc de coralh de cervèu mòrt",
  "block.minecraft.dead_bubble_coral_block": "blòc de coralh de botiòla mòrt",
  "block.minecraft.dead_fire_coral_block": "blòc de coralh de fuòc mòrt",
  "block.minecraft.dead_horn_coral_block": "blòc de coralh cornut mòrt",
  "block.minecraft.tube_coral_block": "blòc de coralh tubular",
  "block.minecraft.brain_coral_block": "blòc de coralh de cervèu",
  "block.minecraft.bubble_coral_block": "blòc de coralh de botiòla",
  "block.minecraft.fire_coral_block": "blòc de coralh de fuòc",
  "block.minecraft.horn_coral_block": "blòc de coralh cornut",
  "block.minecraft.tube_coral": "coralh tubular",
  "block.minecraft.brain_coral": "coralh de cervèu",
  "block.minecraft.bubble_coral": "coralh de botiòla",
  "block.minecraft.fire_coral": "coralh de fuòc",
  "block.minecraft.horn_coral": "coralh cornut",
  "block.minecraft.dead_brain_coral": "coralh de cervèu mòrt",
  "block.minecraft.dead_bubble_coral": "coralh de botiòla mòrt",
  "block.minecraft.dead_fire_coral": "coralh de fuòc mòrt",
  "block.minecraft.dead_horn_coral": "coralh cornut mòrt",
  "block.minecraft.dead_tube_coral": "coralh tubular mòrt",
  "block.minecraft.tube_coral_fan": "gorgònia de coralh tubular",
  "block.minecraft.brain_coral_fan": "gorgònia de coralh de cervèu",
  "block.minecraft.bubble_coral_fan": "gorgònia de coralh de botiòla",
  "block.minecraft.fire_coral_fan": "gorgònia de coralh de fuòc",
  "block.minecraft.horn_coral_fan": "gorgònia de coralh cornut",
  "block.minecraft.dead_tube_coral_fan": "gorgònia de coralh tubular mòrt",
  "block.minecraft.dead_brain_coral_fan": "gorgònia de coralh de cervèu mòrt",
  "block.minecraft.dead_bubble_coral_fan": "gorgònia de coralh de botiòla mòrt",
  "block.minecraft.dead_fire_coral_fan": "gorgònia de coralh de fuòc mòrt",
  "block.minecraft.dead_horn_coral_fan": "gorgònia de coralh cornut mòrt",
  "block.minecraft.blue_ice": "glaç blau",
  "block.minecraft.conduit": "conduch",
  "block.minecraft.polished_granite_stairs": "escalièrs en granit polit",
  "block.minecraft.smooth_red_sandstone_stairs": "escalièrs en gres roge lis",
  "block.minecraft.mossy_stone_brick_stairs": "escalièrs en bricas de pèiras mofudas",
  "block.minecraft.polished_diorite_stairs": "escalièrs en diorit polida",
  "block.minecraft.mossy_cobblestone_stairs": "escalièrs en pèiras mofudas",
  "block.minecraft.end_stone_brick_stairs": "escalièrs en bricas de pèira de l'end",
  "block.minecraft.stone_stairs": "escalièrs de ròca",
  "block.minecraft.smooth_sandstone_stairs": "escalièrs en gres lis",
  "block.minecraft.smooth_quartz_stairs": "escalièrs en qüars lis",
  "block.minecraft.granite_stairs": "escalièrs en granit",
  "block.minecraft.andesite_stairs": "escalièrs d'andesita",
  "block.minecraft.red_nether_brick_stairs": "escalièrs en bricas dau nether rojas",
  "block.minecraft.polished_andesite_stairs": "escalièrs d'andesita polida",
  "block.minecraft.diorite_stairs": "escalièrs de diorita",
  "block.minecraft.polished_granite_slab": "lausa en granit polit",
  "block.minecraft.smooth_red_sandstone_slab": "lausa en gres roge lis",
  "block.minecraft.mossy_stone_brick_slab": "lausa en bricas de pèiras mofudas",
  "block.minecraft.polished_diorite_slab": "lausa en diorita polida",
  "block.minecraft.mossy_cobblestone_slab": "lausa de pèiras mofudas",
  "block.minecraft.end_stone_brick_slab": "lausa en bricas de pèira de l'end",
  "block.minecraft.smooth_sandstone_slab": "lausa en gres lis",
  "block.minecraft.smooth_quartz_slab": "lausa en qüars lis",
  "block.minecraft.granite_slab": "lausa en granit",
  "block.minecraft.andesite_slab": "lausa d'andesita",
  "block.minecraft.red_nether_brick_slab": "lausa en bricas dau nether rojas",
  "block.minecraft.polished_andesite_slab": "lausa d'andesita polida",
  "block.minecraft.diorite_slab": "lausa de diorita",
  "block.minecraft.scaffolding": "enart",
  "block.minecraft.iron_door": "pòrta en fèrre",
  "block.minecraft.oak_door": "pòrta en euse",
  "block.minecraft.spruce_door": "pòrta en avet",
  "block.minecraft.birch_door": "pòrta en bèç",
  "block.minecraft.jungle_door": "pòrta de jungla",
  "block.minecraft.acacia_door": "pòrta en cacièr",
  "block.minecraft.dark_oak_door": "pòrta en euse escur",
  "block.minecraft.crimson_door": "pòrta cremesina",
  "block.minecraft.warped_door": "pòrta bescornuda",
  "block.minecraft.repeater": "repetidor de redstone",
  "block.minecraft.comparator": "comparator de redstone",
  "block.minecraft.structure_block": "blòc d'estructura",
  "block.minecraft.jigsaw": "blòc copacap",
  "item.minecraft.turtle_helmet": "clòsca de tartuga□□sul cap:□+2 armadura",
  "item.minecraft.scute": "escata de tartuga",
  "item.minecraft.iron_shovel": "pala en fèrre□□when in main hand:□+3.5 degalhs d'ataca□-3 velocitat d'ataca",
  "item.minecraft.iron_pickaxe": "trenca en fèrre□□when in main hand:□+3 degalhs d'ataca□-2.8 velocitat d'ataca",
  "item.minecraft.iron_axe": "pigassa en fèrre□□when in main hand:□+8 degalhs d'ataca□-3.1 velocitat d'ataca",
  "item.minecraft.flint_and_steel": "batifuòc",
  "item.minecraft.apple": "poma",
  "item.minecraft.bow": "arc",
  "item.minecraft.arrow": "sageta",
  "item.minecraft.coal": "carbon",
  "item.minecraft.charcoal": "carbon de fusta",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "lingòt de fèrre",
  "item.minecraft.gold_ingot": "lingòt d'aur",
  "item.minecraft.netherite_ingot": "lingòt de netherita",
  "item.minecraft.netherite_scrap": "fragment de netherita",
  "item.minecraft.iron_sword": "espasa en fèrre□□when in main hand:□+5 degalhs d'ataca□-2.4 velocitat d'ataca",
  "item.minecraft.wooden_sword": "espasa en fusta□□when in main hand:□+3 degalhs d'ataca□-2.4 velocitat d'ataca",
  "item.minecraft.wooden_shovel": "pala en fusta□□when in main hand:□+1.5 degalhs d'ataca□-3 velocitat d'ataca",
  "item.minecraft.wooden_pickaxe": "trenca en fusta□□when in main hand:□+1 degalhs d'ataca□-2.8 velocitat d'ataca",
  "item.minecraft.wooden_axe": "pigassa en fusta□□when in main hand:□+6 degalhs d'ataca□-3.2 velocitat d'ataca",
  "item.minecraft.stone_sword": "espasa en pèira□□when in main hand:□+4 degalhs d'ataca□-2.4 velocitat d'ataca",
  "item.minecraft.stone_shovel": "pala en pèira□□when in main hand:□+2.5 degalhs d'ataca□-3 velocitat d'ataca",
  "item.minecraft.stone_pickaxe": "trenca en pèira□□when in main hand:□+2 degalhs d'ataca□-2.8 velocitat d'ataca",
  "item.minecraft.stone_axe": "pigassa en pèira□□when in main hand:□+8 degalhs d'ataca□-3.2 velocitat d'ataca",
  "item.minecraft.diamond_sword": "espasa en diamant□□when in main hand:□+6 degalhs d'ataca□-2.4 velocitat d'ataca",
  "item.minecraft.diamond_shovel": "pala en diamant□□when in main hand:□+4.5 degalhs d'ataca□-3 velocitat d'ataca",
  "item.minecraft.diamond_pickaxe": "trenca en diamant□□when in main hand:□+4 degalhs d'ataca□-2.8 velocitat d'ataca",
  "item.minecraft.diamond_axe": "pigassa en diamant□□when in main hand:□+8 degalhs d'ataca□-3 velocitat d'ataca",
  "item.minecraft.stick": "baston",
  "item.minecraft.bowl": "bòl",
  "item.minecraft.mushroom_stew": "sopa de camparòu",
  "item.minecraft.golden_sword": "espasa en aur□□when in main hand:□+3 degalhs d'ataca□-2.4 velocitat d'ataca",
  "item.minecraft.golden_shovel": "pala en aur□□when in main hand:□+1.5 degalhs d'ataca□-3 velocitat d'ataca",
  "item.minecraft.golden_pickaxe": "trenca en aur□□when in main hand:□+1 degalhs d'ataca□-2.8 velocitat d'ataca",
  "item.minecraft.golden_axe": "pigassa en aur□□when in main hand:□+6 degalhs d'ataca□-3 velocitat d'ataca",
  "item.minecraft.netherite_sword": "espasa en netherita□□when in main hand:□+7 degalhs d'ataca□-2.4 velocitat d'ataca",
  "item.minecraft.netherite_shovel": "pala en netherita□□when in main hand:□+5.5 degalhs d'ataca□-3 velocitat d'ataca",
  "item.minecraft.netherite_pickaxe": "trenca en netherita□□when in main hand:□+5 degalhs d'ataca□-2.8 velocitat d'ataca",
  "item.minecraft.netherite_axe": "pigassa en netherita□□when in main hand:□+9 degalhs d'ataca□-3 velocitat d'ataca",
  "item.minecraft.string": "fiau",
  "item.minecraft.feather": "pluma",
  "item.minecraft.gunpowder": "pouvera",
  "item.minecraft.wooden_hoe": "bigòs en fusta□□when in main hand:□-3 velocitat d'ataca",
  "item.minecraft.stone_hoe": "bigòs en pèira□□when in main hand:□-2 velocitat d'ataca",
  "item.minecraft.iron_hoe": "bigòs en fèrre□□when in main hand:□-1 velocitat d'ataca",
  "item.minecraft.diamond_hoe": "bigòs en diamant□□when in main hand:",
  "item.minecraft.golden_hoe": "bigòs en aur□□when in main hand:□-3 velocitat d'ataca",
  "item.minecraft.netherite_hoe": "bigòs en netherita□□when in main hand:",
  "item.minecraft.wheat_seeds": "granas de blat",
  "item.minecraft.wheat": "blat",
  "item.minecraft.bread": "pan",
  "item.minecraft.leather_helmet": "capèu en cuèr□□sul cap:□+1 armadura",
  "item.minecraft.leather_chestplate": "tunica en cuèr□□sus lo còrs:□+3 armadura",
  "item.minecraft.leather_leggings": "pantalons en cuèr□□when on legs:□+2 armadura",
  "item.minecraft.leather_boots": "bòtas en cuèr□□when on feet:□+1 armadura",
  "item.minecraft.chainmail_helmet": "casco en còta de malhas□□sul cap:□+2 armadura",
  "item.minecraft.chainmail_chestplate": "plastron en còta de malhas□□sus lo còrs:□+5 armadura",
  "item.minecraft.chainmail_leggings": "cambièras en còta de malhas□□when on legs:□+4 armadura",
  "item.minecraft.chainmail_boots": "bòtas en còta de malhas□□when on feet:□+1 armadura",
  "item.minecraft.iron_helmet": "casco en fèrre□□sul cap:□+2 armadura",
  "item.minecraft.iron_chestplate": "plastron en fèrre□□sus lo còrs:□+6 armadura",
  "item.minecraft.iron_leggings": "cambièras en fèrre□□when on legs:□+5 armadura",
  "item.minecraft.iron_boots": "bòtas en fèrre□□when on feet:□+2 armadura",
  "item.minecraft.diamond_helmet": "casco en diamant□□sul cap:□+3 armadura□+2 robustessa de l'armadura",
  "item.minecraft.diamond_chestplate": "plastron en diamant□□sus lo còrs:□+8 armadura□+2 robustessa de l'armadura",
  "item.minecraft.diamond_leggings": "cambièras en diamant□□when on legs:□+6 armadura□+2 robustessa de l'armadura",
  "item.minecraft.diamond_boots": "bòtas en diamant□□when on feet:□+3 armadura□+2 robustessa de l'armadura",
  "item.minecraft.golden_helmet": "casco en aur□□sul cap:□+2 armadura",
  "item.minecraft.golden_chestplate": "plastron en aur□□sus lo còrs:□+5 armadura",
  "item.minecraft.golden_leggings": "cambièras en aur□□when on legs:□+3 armadura",
  "item.minecraft.golden_boots": "bòtas en aur□□when on feet:□+1 armadura",
  "item.minecraft.netherite_helmet": "casco en netherita□□sul cap:□+3 armadura□+3 robustessa de l'armadura□+1 resistància a la reculada",
  "item.minecraft.netherite_chestplate": "plastron en netherita□□sus lo còrs:□+8 armadura□+3 robustessa de l'armadura□+1 resistància a la reculada",
  "item.minecraft.netherite_leggings": "cambièras en netherita□□when on legs:□+6 armadura□+3 robustessa de l'armadura□+1 resistància a la reculada",
  "item.minecraft.netherite_boots": "bòtas en netherita□□when on feet:□+3 armadura□+3 robustessa de l'armadura□+1 resistància a la reculada",
  "item.minecraft.flint": "frejau",
  "item.minecraft.porkchop": "costeleta de pòrc crusa",
  "item.minecraft.cooked_porkchop": "costeleta de pòrc cuèch",
  "item.minecraft.painting": "pintura",
  "item.minecraft.golden_apple": "poma daurada",
  "item.minecraft.enchanted_golden_apple": "poma daurada encantada",
  "block.minecraft.oak_sign": "pancarta en euse",
  "block.minecraft.spruce_sign": "pancarta en avet",
  "block.minecraft.birch_sign": "pancarta en bèç",
  "block.minecraft.jungle_sign": "pancarta de jungla",
  "block.minecraft.acacia_sign": "pancarta en cacièr",
  "block.minecraft.dark_oak_sign": "pancarta en euse escur",
  "block.minecraft.crimson_sign": "pancarta cremesina",
  "block.minecraft.warped_sign": "pancarta bescornuda",
  "item.minecraft.bucket": "ferrat",
  "item.minecraft.water_bucket": "ferrat d'aiga",
  "item.minecraft.lava_bucket": "ferrat de lava",
  "item.minecraft.minecart": "vagonet",
  "item.minecraft.saddle": "sèla",
  "item.minecraft.redstone": "polsa de redstone",
  "item.minecraft.snowball": "bola de nèu",
  "item.minecraft.oak_boat": "batèu en euse",
  "item.minecraft.leather": "cuèr",
  "item.minecraft.milk_bucket": "ferrat de lach",
  "item.minecraft.pufferfish_bucket": "peis-glòbe dins un ferrat",
  "item.minecraft.salmon_bucket": "saumon dins un ferrat",
  "item.minecraft.cod_bucket": "merluça dins un ferrat",
  "item.minecraft.tropical_fish_bucket": "peis tropicau dins un ferrat",
  "item.minecraft.brick": "brica",
  "item.minecraft.clay_ball": "bola d'argila",
  "block.minecraft.dried_kelp_block": "blòc d'augas secadas",
  "item.minecraft.paper": "papièr",
  "item.minecraft.book": "libre",
  "item.minecraft.slime_ball": "bola de slime",
  "item.minecraft.chest_minecart": "vagonet amb còfre",
  "item.minecraft.furnace_minecart": "vagonet amb forn",
  "item.minecraft.egg": "uòu",
  "item.minecraft.compass": "bossòla",
  "item.minecraft.fishing_rod": "cana de pesca",
  "item.minecraft.clock": "relòtge",
  "item.minecraft.glowstone_dust": "polsa de pèira luminosa",
  "item.minecraft.cod": "merluça crusa",
  "item.minecraft.salmon": "saumon crus",
  "item.minecraft.tropical_fish": "peis tropicau",
  "item.minecraft.pufferfish": "peis glòbe",
  "item.minecraft.cooked_cod": "merluça cuècha",
  "item.minecraft.cooked_salmon": "saumon cuèch",
  "item.minecraft.ink_sac": "sac de tencha",
  "item.minecraft.red_dye": "tencha roja",
  "item.minecraft.green_dye": "tencha verda",
  "item.minecraft.cocoa_beans": "cacau",
  "item.minecraft.lapis_lazuli": "lapislazuli",
  "item.minecraft.purple_dye": "tencha violeta",
  "item.minecraft.cyan_dye": "tencha cian",
  "item.minecraft.light_gray_dye": "tencha gris clar",
  "item.minecraft.gray_dye": "tencha gris",
  "item.minecraft.pink_dye": "tencha ròsa",
  "item.minecraft.lime_dye": "tencha lima",
  "item.minecraft.yellow_dye": "tencha jauna",
  "item.minecraft.light_blue_dye": "tencha blau clar",
  "item.minecraft.magenta_dye": "tencha magenta",
  "item.minecraft.orange_dye": "tencha iranja",
  "item.minecraft.bone_meal": "polsa d'òs",
  "item.minecraft.blue_dye": "tencha blava",
  "item.minecraft.brown_dye": "tencha bruna",
  "item.minecraft.black_dye": "tencha negra",
  "item.minecraft.white_dye": "tencha blanca",
  "item.minecraft.bone": "òs",
  "item.minecraft.sugar": "sucre",
  "block.minecraft.cake": "pastís",
  "block.minecraft.white_bed": "lièch blanc",
  "block.minecraft.orange_bed": "lièch irange",
  "block.minecraft.magenta_bed": "lièch magenta",
  "block.minecraft.light_blue_bed": "lièch blau clar",
  "block.minecraft.yellow_bed": "lièch jaune",
  "block.minecraft.lime_bed": "lièch lima",
  "block.minecraft.pink_bed": "lièch ròse",
  "block.minecraft.gray_bed": "lièch gris",
  "block.minecraft.light_gray_bed": "lièch gris clar",
  "block.minecraft.cyan_bed": "lièch cian",
  "block.minecraft.purple_bed": "lièch violet",
  "block.minecraft.blue_bed": "lièch blau",
  "block.minecraft.brown_bed": "lièch brun",
  "block.minecraft.green_bed": "lièch verd",
  "block.minecraft.red_bed": "lièch roge",
  "block.minecraft.black_bed": "lièch negre",
  "item.minecraft.cookie": "coqueta",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "cisalhas",
  "item.minecraft.melon_slice": "talhon de pastèca",
  "item.minecraft.dried_kelp": "augas secadas",
  "item.minecraft.pumpkin_seeds": "granas de coja",
  "item.minecraft.melon_seeds": "granas de pastèca",
  "item.minecraft.beef": "buòu crus",
  "item.minecraft.cooked_beef": "bistèc",
  "item.minecraft.chicken": "polastre crus",
  "item.minecraft.cooked_chicken": "polastre cuèch",
  "item.minecraft.rotten_flesh": "carn poirida",
  "item.minecraft.ender_pearl": "pèrla de l'end",
  "item.minecraft.blaze_rod": "baston de blaze",
  "item.minecraft.ghast_tear": "lagrema de ghast",
  "item.minecraft.gold_nugget": "pepita d'aur",
  "item.minecraft.nether_wart": "verruga dau nether",
  "item.minecraft.potion": "pocion non fabricabla□cap d'efièch",
  "item.minecraft.glass_bottle": "fiòla",
  "item.minecraft.spider_eye": "uèlh d'aranha",
  "item.minecraft.fermented_spider_eye": "uèlh d'aranha fermentat",
  "item.minecraft.blaze_powder": "polsa de blaze",
  "item.minecraft.magma_cream": "crèma de magma",
  "block.minecraft.brewing_stand": "alambic",
  "block.minecraft.cauldron": "pairòla",
  "item.minecraft.ender_eye": "uèlh d'ender",
  "item.minecraft.glistering_melon_slice": "talhon de pastèca daurada",
  "item.minecraft.bat_spawn_egg": "uòu d'aparicion de ratapenada",
  "item.minecraft.bee_spawn_egg": "uòu d'aparicion d'abelha",
  "item.minecraft.blaze_spawn_egg": "uòu d'aparicion de blaze",
  "item.minecraft.cat_spawn_egg": "uòu d'aparicion de cat",
  "item.minecraft.cave_spider_spawn_egg": "uòu d'aparicion d'aranha de bauma",
  "item.minecraft.chicken_spawn_egg": "uòu d'aparicion de polastre",
  "item.minecraft.cod_spawn_egg": "uòu d'aparicion de merluça",
  "item.minecraft.cow_spawn_egg": "uòu d'aparicion de vaca",
  "item.minecraft.creeper_spawn_egg": "uòu d'aparicion de creeper",
  "item.minecraft.dolphin_spawn_egg": "uòu d'aparicion de daufin",
  "item.minecraft.donkey_spawn_egg": "uòu d'aparicion d'ase",
  "item.minecraft.drowned_spawn_egg": "uòu d'aparicion de negat",
  "item.minecraft.elder_guardian_spawn_egg": "uòu d'aparicion de grand gardian",
  "item.minecraft.enderman_spawn_egg": "uòu d'aparicion d'enderòme",
  "item.minecraft.endermite_spawn_egg": "uòu d'aparicion d'enderarna",
  "item.minecraft.evoker_spawn_egg": "uòu d'aparicion d'evocator",
  "item.minecraft.fox_spawn_egg": "uòu d'aparicion de rainard",
  "item.minecraft.ghast_spawn_egg": "uòu d'aparicion de ghast",
  "item.minecraft.guardian_spawn_egg": "uòu d'aparicion de gardian",
  "item.minecraft.hoglin_spawn_egg": "uòu d'aparicion de hoglin",
  "item.minecraft.horse_spawn_egg": "uòu d'aparicion de cavau",
  "item.minecraft.husk_spawn_egg": "uòu d'aparicion de zòmbi momificat",
  "item.minecraft.llama_spawn_egg": "uòu d'aparicion de lama",
  "item.minecraft.magma_cube_spawn_egg": "uòu d'aparicion de cube de magma",
  "item.minecraft.mooshroom_spawn_egg": "uòu d'aparicion de vacamparòu",
  "item.minecraft.mule_spawn_egg": "uòu d'aparicion de mula",
  "item.minecraft.ocelot_spawn_egg": "uòu d'aparcion d'ocelòt",
  "item.minecraft.panda_spawn_egg": "uòu d'aparicion de panda",
  "item.minecraft.parrot_spawn_egg": "uòu d'aparcion de papagai",
  "item.minecraft.phantom_spawn_egg": "uòu d'aparicion de fantauma",
  "item.minecraft.pig_spawn_egg": "uòu d'aparicion de pòrc",
  "item.minecraft.piglin_spawn_egg": "uòu d'aparicion de piglin",
  "item.minecraft.pillager_spawn_egg": "uòu d'aparicion de pilhard",
  "item.minecraft.polar_bear_spawn_egg": "uòu d'aparicion d'ors polar",
  "item.minecraft.pufferfish_spawn_egg": "uòu d'aparicion de peis glòbe",
  "item.minecraft.rabbit_spawn_egg": "uòu d'aparicion de conilh",
  "item.minecraft.ravager_spawn_egg": "uòu d'aparicion de devastator",
  "item.minecraft.salmon_spawn_egg": "uòu d'aparcion de saumon",
  "item.minecraft.sheep_spawn_egg": "uòu d'aparicion de moton",
  "item.minecraft.shulker_spawn_egg": "uòu d'aparicion de shulker",
  "item.minecraft.silverfish_spawn_egg": "uòu d'aparicion de peis d'argent",
  "item.minecraft.skeleton_spawn_egg": "uòu d'aparicion d'esqueleta",
  "item.minecraft.skeleton_horse_spawn_egg": "uòu d'aparicion de cavau esqueleta",
  "item.minecraft.slime_spawn_egg": "uòu d'aparicion de slime",
  "item.minecraft.spider_spawn_egg": "uòu d'aparicion d'aranha",
  "item.minecraft.squid_spawn_egg": "uòu d'aparicion de tautena",
  "item.minecraft.stray_spawn_egg": "uòu d'aparicion de barrutlaire",
  "item.minecraft.strider_spawn_egg": "uòu d'aparicion d'arpentaire",
  "item.minecraft.trader_llama_spawn_egg": "uòu d'aparicion de lama ambulanta",
  "item.minecraft.tropical_fish_spawn_egg": "uòu d'aparicion de peis tropicau",
  "item.minecraft.turtle_spawn_egg": "uòu d'aparicion de tartuga",
  "item.minecraft.vex_spawn_egg": "uòu d'aparicion de vex",
  "item.minecraft.villager_spawn_egg": "uòu d'aparicion de vilatgés",
  "item.minecraft.vindicator_spawn_egg": "uòu d'aparicion de vindicator",
  "item.minecraft.wandering_trader_spawn_egg": "uòu d'aparicion de mercant ambulant",
  "item.minecraft.witch_spawn_egg": "uòu d'aparicion de masca",
  "item.minecraft.wither_skeleton_spawn_egg": "uòu d'aparicion d'esqueleta wither",
  "item.minecraft.wolf_spawn_egg": "uòu d'aparicion de lop",
  "item.minecraft.zoglin_spawn_egg": "uòu d'aparicion de zoglin",
  "item.minecraft.zombie_spawn_egg": "uòu d'aparicion de zòmbi",
  "item.minecraft.zombie_horse_spawn_egg": "uòu d'aparicion de cavau zòmbi",
  "item.minecraft.zombie_villager_spawn_egg": "uòu d'aparicion de zòmbi vilatgés",
  "item.minecraft.zombified_piglin_spawn_egg": "uòu d'aparicion de piglin zombificat",
  "item.minecraft.experience_bottle": "fiòla d'experiéncia",
  "item.minecraft.fire_charge": "pelòta de fuòc",
  "item.minecraft.writable_book": "libre e pluma",
  "item.minecraft.written_book": "libre escrich",
  "item.minecraft.emerald": "esmerauda",
  "item.minecraft.item_frame": "quadre",
  "block.minecraft.flower_pot": "topin",
  "item.minecraft.carrot": "pastenaga",
  "item.minecraft.potato": "patana",
  "item.minecraft.baked_potato": "patana cuècha",
  "item.minecraft.poisonous_potato": "patana empoisonada",
  "item.minecraft.map": "mapa verge",
  "item.minecraft.golden_carrot": "pastenaga daurada",
  "block.minecraft.skeleton_skull": "cran d'esqueleta",
  "block.minecraft.wither_skeleton_skull": "cran d'esqueleta wither",
  "block.minecraft.player_head": "cap de jogaire",
  "block.minecraft.zombie_head": "cap de zòmbi",
  "block.minecraft.creeper_head": "cap de creeper",
  "block.minecraft.dragon_head": "cap de dragon",
  "item.minecraft.carrot_on_a_stick": "pastenaga sus un baston",
  "item.minecraft.warped_fungus_on_a_stick": "fonge bescornut sus un baston",
  "item.minecraft.nether_star": "estela dau nether",
  "item.minecraft.pumpkin_pie": "tarta de coja",
  "item.minecraft.firework_rocket": "fuòc d'artifici",
  "item.minecraft.firework_star": "estela de fuòc d'artifici",
  "item.minecraft.enchanted_book": "libre encantat",
  "item.minecraft.nether_brick": "brica dau nether",
  "item.minecraft.quartz": "qüars dau nether",
  "item.minecraft.tnt_minecart": "vagonet amb de tnt",
  "item.minecraft.hopper_minecart": "vagonet amb embut",
  "item.minecraft.prismarine_shard": "tròç de prismarina",
  "item.minecraft.prismarine_crystals": "cristaus de prismarina",
  "item.minecraft.rabbit": "conilh crus",
  "item.minecraft.cooked_rabbit": "conilh cuèch",
  "item.minecraft.rabbit_stew": "fricòt de conilh",
  "item.minecraft.rabbit_foot": "pauta de conilh",
  "item.minecraft.rabbit_hide": "pèu de conilh",
  "item.minecraft.armor_stand": "pòrta-armadura",
  "item.minecraft.iron_horse_armor": "armadura en fèrre per cavau",
  "item.minecraft.golden_horse_armor": "armadura en aur per cavau",
  "item.minecraft.diamond_horse_armor": "armadura en diamant per cavau",
  "item.minecraft.leather_horse_armor": "armadura en cuèr per cavau",
  "item.minecraft.lead": "laç",
  "item.minecraft.name_tag": "etiqueta",
  "item.minecraft.command_block_minecart": "vagonet amb blòc de comandas",
  "item.minecraft.mutton": "moton crus",
  "item.minecraft.cooked_mutton": "moton cuèch",
  "block.minecraft.white_banner": "bandièra blanca",
  "block.minecraft.orange_banner": "bandièra iranja",
  "block.minecraft.magenta_banner": "bandièra magenta",
  "block.minecraft.light_blue_banner": "bandièra blau clar",
  "block.minecraft.yellow_banner": "bandièra jauna",
  "block.minecraft.lime_banner": "bandièra lima",
  "block.minecraft.pink_banner": "bandièra ròsa",
  "block.minecraft.gray_banner": "bandièra grisa",
  "block.minecraft.light_gray_banner": "bandièra gris clar",
  "block.minecraft.cyan_banner": "bandièra cian",
  "block.minecraft.purple_banner": "bandièra violeta",
  "block.minecraft.blue_banner": "bandièra blava",
  "block.minecraft.brown_banner": "bandièra bruna",
  "block.minecraft.green_banner": "bandièra verda",
  "block.minecraft.red_banner": "bandièra roja",
  "block.minecraft.black_banner": "bandièra negra",
  "item.minecraft.end_crystal": "cristau de l'end",
  "item.minecraft.chorus_fruit": "fruch de còrus",
  "item.minecraft.popped_chorus_fruit": "fruch de còrus esclatada",
  "item.minecraft.beetroot": "bledarava",
  "item.minecraft.beetroot_seeds": "granas de bledarava",
  "item.minecraft.beetroot_soup": "sopa de bledarava",
  "item.minecraft.dragon_breath": "buf de dragon",
  "item.minecraft.splash_potion": "pocion getabla non fabricabla□cap d'efièch",
  "item.minecraft.spectral_arrow": "sageta espectrala",
  "item.minecraft.tipped_arrow": "sageta especiala non fabricabla□cap d'efièch",
  "item.minecraft.lingering_potion": "pocion de persisténcia non fabricabla□cap d'efièch",
  "item.minecraft.shield": "bloquièr",
  "item.minecraft.elytra": "elitres",
  "item.minecraft.spruce_boat": "batèu en avet",
  "item.minecraft.birch_boat": "batèu en bèç",
  "item.minecraft.jungle_boat": "batèu de jungla",
  "item.minecraft.acacia_boat": "batèu en cacièr",
  "item.minecraft.dark_oak_boat": "batèu en euse escur",
  "item.minecraft.totem_of_undying": "totèm d'immortalitat",
  "item.minecraft.shulker_shell": "clòsca de shulker",
  "item.minecraft.iron_nugget": "pepita de fèrre",
  "item.minecraft.knowledge_book": "libre de las coneissénças",
  "item.minecraft.debug_stick": "baston de desbogatge",
  "item.minecraft.music_disc_13": "disc de musica□c418 - 13",
  "item.minecraft.music_disc_cat": "disc de musica□c418 - cat",
  "item.minecraft.music_disc_blocks": "disc de musica□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disc de musica□c418 - chirp",
  "item.minecraft.music_disc_far": "disc de musica□c418 - far",
  "item.minecraft.music_disc_mall": "disc de musica□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disc de musica□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disc de musica□c418 - stal",
  "item.minecraft.music_disc_strad": "disc de musica□c418 - strad",
  "item.minecraft.music_disc_ward": "disc de musica□c418 - ward",
  "item.minecraft.music_disc_11": "disc de musica□c418 - 11",
  "item.minecraft.music_disc_wait": "disc de musica□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disc de musica□lena raine - pigstep",
  "item.minecraft.trident": "trident□□when in main hand:□+8 degalhs d'ataca□-2.9 velocitat d'ataca",
  "item.minecraft.phantom_membrane": "membrana de fantauma",
  "item.minecraft.nautilus_shell": "clòsca de nautile",
  "item.minecraft.heart_of_the_sea": "còr de la mar",
  "item.minecraft.crossbow": "balèsta",
  "item.minecraft.suspicious_stew": "sopa suspècta",
  "block.minecraft.loom": "telièr",
  "item.minecraft.flower_banner_pattern": "motiu de bandièra□flor",
  "item.minecraft.creeper_banner_pattern": "motiu de bandièra□fàcia de creeper",
  "item.minecraft.skull_banner_pattern": "motiu de bandièra□cran",
  "item.minecraft.mojang_banner_pattern": "motiu de bandièra□simbòle",
  "item.minecraft.globe_banner_pattern": "motiu de bandièra□glòbe",
  "item.minecraft.piglin_banner_pattern": "motiu de bandièra□morre",
  "block.minecraft.composter": "compostador",
  "block.minecraft.barrel": "barrica",
  "block.minecraft.smoker": "fumador",
  "block.minecraft.blast_furnace": "fornèu de fusion",
  "block.minecraft.cartography_table": "taula de cartografia",
  "block.minecraft.fletching_table": "taula d'arqueria",
  "block.minecraft.grindstone": "mòla",
  "block.minecraft.lectern": "pupitre",
  "block.minecraft.smithing_table": "taula de fargatge",
  "block.minecraft.stonecutter": "peirièr",
  "block.minecraft.bell": "campana",
  "block.minecraft.lantern": "lantèrna",
  "block.minecraft.soul_lantern": "lantèrna d'anmas",
  "item.minecraft.sweet_berries": "bagas doças",
  "block.minecraft.campfire": "fuòc de camp",
  "block.minecraft.soul_campfire": "fuòc de camp d'anmas",
  "block.minecraft.shroomlight": "lamparòu",
  "item.minecraft.honeycomb": "bresca",
  "block.minecraft.bee_nest": "nis d'abelhas",
  "block.minecraft.beehive": "bornhon artificiau",
  "item.minecraft.honey_bottle": "fiòla de mèu",
  "block.minecraft.honey_block": "blòc de mèu",
  "block.minecraft.honeycomb_block": "blòc de bresca",
  "block.minecraft.lodestone": "magnetita",
  "block.minecraft.netherite_block": "blòc de netherita",
  "block.minecraft.ancient_debris": "brigalhs antics",
  "block.minecraft.target": "buta",
  "block.minecraft.crying_obsidian": "obsidiana plorosa",
  "block.minecraft.blackstone": "ròca negra",
  "block.minecraft.blackstone_slab": "lausa de ròca negra",
  "block.minecraft.blackstone_stairs": "escalièrs de ròca negra",
  "block.minecraft.gilded_blackstone": "ròca negra daurada",
  "block.minecraft.polished_blackstone": "ròca negra polida",
  "block.minecraft.polished_blackstone_slab": "lausa de ròca negra polida",
  "block.minecraft.polished_blackstone_stairs": "escalièrs de ròca negra polida",
  "block.minecraft.chiseled_polished_blackstone": "ròca negra escultada",
  "block.minecraft.polished_blackstone_bricks": "bricas de ròca negra polida",
  "block.minecraft.polished_blackstone_brick_slab": "lausa en bricas de ròca negra polida",
  "block.minecraft.polished_blackstone_brick_stairs": "escalièrs en bricas de ròca negra polida",
  "block.minecraft.cracked_polished_blackstone_bricks": "bricas de ròca negra fendilhadas",
  "block.minecraft.respawn_anchor": "ancora de reaparicion",
}
export const oc_fr = items; 
